import axios from "axios";


import {
  callWithRetryGuard
} from "../components/utils/RetryManager";
const {
  REACT_APP_SIMULATION_URL,
  REACT_APP_PREVIEW_CONTRAT_API_URL,
  REACT_APP_PREVIEW_MANDAT_API_URL,
  REACT_APP_SIGN_CONTRAT_API_URL,
  REACT_APP_SIGN_MANDAT_API_URL,
  REACT_APP_ENVOI_CONTRAT_MANDAT_API_URL,
  REACT_APP_UPDATE_DEM_WITH_CONTRACTS,
  REACT_APP_GET_STATUT_DEMANDE_URL
} = process.env;
const header = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "true",
};

export class AncvService {

  getSimulationResults(simParams) {
    const simulationDTO = {
      montantTotal: simParams.montantTotal ? simParams.montantTotal : null,
      montantMensualite: simParams.montantMensualite ? simParams.montantMensualite : null,
      nombreMensualite: simParams.nombreMensualite ? simParams.nombreMensualite : null,
      exercice: simParams.exercice,
      numCgos: simParams.numCgos
    }
    return axios.post(REACT_APP_SIMULATION_URL, simulationDTO, header);
  }

  async submitContratMandat(demande) {
    return callWithRetryGuard(demande.numeroCGOS,() =>
     axios.post(REACT_APP_ENVOI_CONTRAT_MANDAT_API_URL, demande,{
      headers: header,
      withCredentials: 'omit'
    })
  );
  }

  //for Test purpose DDPMCO-187   //REACT_APP_PREVIEW_CONTRAT_API_URL
  async previewContrat(demande) {
    return callWithRetryGuard(demande.numeroCGOS,() =>
      axios.post(
        REACT_APP_PREVIEW_CONTRAT_API_URL,
        demande,
        { withCredentials: 'omit', responseType: 'blob' }
      )
    );
  }

  

  async  previewMandat(demande) {
    return callWithRetryGuard(demande.numeroCGOS,() =>
      axios.post(
        REACT_APP_PREVIEW_MANDAT_API_URL,
        demande,
        { withCredentials: 'omit', responseType: 'blob' }
      )
    );
  }

  async signContrat(demande) {

      return callWithRetryGuard(demande.numeroCGOS,() =>
      axios.post(REACT_APP_SIGN_CONTRAT_API_URL, demande,{
        headers: header,
        withCredentials: 'omit'
      })
    );
  }

  async signMandat(demande) {
    return callWithRetryGuard(demande.numeroCGOS,() =>
    axios.post(REACT_APP_SIGN_MANDAT_API_URL, demande,{
      headers: header,
      withCredentials: 'omit'
    })
  );
  }


  async submitEditedFormWithContracts(demande) {
      return callWithRetryGuard(demande.numeroCGOS,() =>
      axios.post(REACT_APP_UPDATE_DEM_WITH_CONTRACTS, demande,{
        headers: header,
        withCredentials: 'omit'
      })
    );
    }

  getDemandeStatut(demandeId) {
     return axios.get(REACT_APP_GET_STATUT_DEMANDE_URL + "?demandeId=" + demandeId );
  }

}
